/**
*
* Form4Separate
* Use Form4 where filed can individually be edited and submitted
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Form4 from './index.jsx';

function Form4Separate(props) {
  // eslint-disable-next-line no-unused-vars
  const { schema, onSubmit, navigationWarning, children, ...rest } = props;
  const [selected, setSelected] = useState(null);
  const { id, properties } = schema;

  function handleSubmit(key, value) {
    onSubmit(key, value);
    setSelected(null);
  }

  function handleFormSubmit(values) {
    if (selected) {
      handleSubmit(selected, values[selected]);
    }
  }

  const newSchema = {
    id,
    properties: properties.map((p) => ({
      ...p,
      disabled: selected && selected !== p.id,
      onEdit: selected !== p.id ? (() => setSelected(p.id)) : undefined,
      onCancel: selected === p.id ? (() => setSelected(null)) : undefined,
      onSubmit: selected === p.id ? (handleSubmit) : undefined,
      noValidate: selected !== p.id,
    })),
  };

  return (
    <Form4
      formGroupClass="mb-0"
      {...rest}
      schema={newSchema}
      navigationWarning={navigationWarning && selected}
      onSubmit={handleFormSubmit}
    >
      {children || (({ body }) => body)}
    </Form4>
  );
}

Form4Separate.propTypes = {
  children: PropTypes.func,
  schema: PropTypes.object,
  onSubmit: PropTypes.func,
  navigationWarning: PropTypes.bool,
};

export default Form4Separate;
